import { Controller } from '@hotwired/stimulus'

import { targetUpdate } from './components/component_controller'
import { HTMLElementEvent } from '../types'

export class ToggleDisabledController extends Controller {
  static targets = ['input']

  declare readonly inputTarget: HTMLInputElement

  toggle(event: HTMLElementEvent<HTMLInputElement>) {
    const value = event.currentTarget.dataset.defaultValue
    const disabled = !event.target.checked
    if (disabled) {
      targetUpdate(this.inputTarget, { disabled: true, value: null })
    } else {
      const options: { disabled: boolean; value?: string } = { disabled: false }
      if (value) options.value = value
      targetUpdate(this.inputTarget, options)
    }
  }
}
